<template>
  <div>
    <table border="1" cellspacing="0">
  <tr>
    <td width="557" valign="top" colspan="4">
    <img style="width:100%;" src="https://www.zcte.ltd/img/1/nmg1.png?id=979146"/>
    </td>
  </tr>
  <tr style="display:">
    <td width="84">许可证号</td>
    <td width="472" colspan="3" class="digzt">{{info.licence}}</td>
  </tr>
  <tr>
    <td width="84">执行标准</td>
    <td width="472" colspan="3" class="digzt">{{info.standards}}</td>
  </tr>
  <tr>
    <td width="84">产品名称</td>
    <td width="197">{{info.name}}</td>
    <td width="76">批号</td>
    <td width="198">{{info.batch}}</td>
  </tr>
  <tr>
    <td width="84">牌号</td>
    <td width="197">{{info.brand}}</td>
    <td width="76">规格</td>
    <td width="198">{{info.specifications}}</td>
  </tr>
  <tr>
    <td width="84">卷号</td>
    <td width="197">{{info.floder}}</td>
    <td width="76">重量</td>
    <td width="198">{{info.weight}}</td>
  </tr>
  <tr>
    <td width="84">生产日期</td>
    <td width="197">{{ info.date }} {{info.time}}</td>
    <td width="76">班次</td>
    <td width="198">{{info.team}}</td>
  </tr>
  <tr>
    <td width="282" colspan="2">防伪校验码</td>
    <td width="275" colspan="2" class="digzt">{{info.vcode}}</td>
  </tr>
  <tr>
    <td width="557" valign="top" colspan="4" style="text-align:left;">
    　　内蒙古亚新隆顺特钢有限公司总投资36亿元。占地约2000亩，具备铁、钢、材近300万吨/年的生产能力，是集烧结、球团、炼铁、炼钢、轧钢、运输为一体的大型现代化钢铁联合企业。公司通过能源、质量、环境、职业健康安全管理四项休系认证、MC中治产品认证及CNAS实验室认证。公司已连续数年荣登内蒙古民营企业100强" 榜单，荣获"中国中铁集团优质供应商"、"包头市政府质量奖"、"包头市对外开放企业"、"包头市诚信企业"、"包头市爱心企业"等荣誉称号。公司以"推动钢铁产业绿色发展" 为使命，不断提升竞争力，致力成为中国北方钢铁行业引领者 <br />
　　地址;内蒙古包头市石拐工业园区<br />
　　电话∶0472-8729555，8729171 <br />
　　网址∶<a href="http://www.nmgyxls.com">www.nmgyxls.com</a>
　　<div style="width:100%; text-align:center;"><img src="https://www.zcte.ltd/img/1/foot-1.PNG" alt="1" width="90%" style="margin: 10px 5%;"/></div>
    </td>
  </tr>
  </table><div id="zbsan" class="zbsan" style="width:100%;"></div>
<div id="zbsnr" class="zbsnr" style="width:100%;"></div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  mounted() {
    console.log(this.info);
  },
};
</script>

<style scoped>
.digzt {
  font-size: 20px;
  vertical-align: middle;
  text-align: center;
}
table td {
  vertical-align: middle;
  text-align: center;
  padding: 5px 5px;
}
.zbsul {
  width: 94%;
  margin: auto;
  padding: 0px;
}
.zbsul li {
  border-bottom: #aaa 1px solid;
  list-style-position: inside;
  width: 100%;
  padding: 5px 0px;
  color: #aaa;
}
.zbsul li span {
  display: inline-block;
  width: 30%;
}
.zbsul li span:first-child {
  text-align: left;
}
.zbsul li span:last-child {
  text-align: right;
}
.text1 {
  width: 30%;
  border-bottom: #aaa 1px solid;
  padding-left: 3%;
  padding-top: 10px;
}
.text2 {
  border-bottom: #aaa 1px solid;
  text-align: center;
  padding-top: 10px;
}
.text3 {
  width: 30%;
  border-bottom: #aaa 1px solid;
  text-align: right;
  padding-right: 3%;
  padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/manufacturers10.vue